import api from '@/services/api';

const actions = {
  async fetchConfig() {
    const res = await api.get('/renewal/config');
    return res.data;
  },

  async identify(_, token) {
    const res = await api.post('/renewal/identify', { token });
    return res.data;
  },

  async createOrder(_, payload) {
    const res = await api.post('/renewal/order', payload);
    return res.data;
  },

  async verifyPayment(_, payload) {
    const res = await api.post('/renewal/verify', payload);
    return res.data;
  },

  async checkOrderStatus(_, orderId) {
    const res = await api.get(`/renewal/order/${orderId}/status`);
    return res.data;
  },
};

export default { namespaced: true, actions };
